import React from "react";

const PricingContent = [
  {
    icon: "140",
    packName: "Gratis",
    features: [
      "Profil usaha di platform", 
      "mentoring", 
      "Akses ke knowledge base dan tutorial", 
      "Komunitas support grup", 
      "Notifikasi peluang bisnis"],
    price: "0",
    trialText: "dianjurkan sharing testimoni/pengalaman untuk membantu sesama",
    activeClass: "",
    delayAnimation: "",
  },
  {
    icon: "141",
    packName: "Bertumbuh",
    features: [
      "Gratis +",
      "Akses ke workshop & webinar eksklusif",
      "Produk promosi",
      "Kontrol kualitas",
      "Akses ke template kontrak dan dokumen legal",
    ],
    price: "200rb",
    trialText: "1 mentor diaspora + akses pasar global + komunitas + workshop",
    activeClass: "active",
    delayAnimation: "200",
  },
  {
    icon: "142",
    packName: "Berdampak",
    features: [
      "Bertumbuh +",
      "Mentoring dari beberapa mentor diaspora",
      "Akses ke peluang pendanaan dan investasi",
      "Pendampingan ekspor dan akses pasar global",
    ],
    price: "500rb",
    trialText: "Akses ke mentor diaspora dari beberapa bidang + akses pasar global + komunitas + workshop",
    activeClass: "",
    delayAnimation: "400",
  },
];

const PricingSeven = () => {
  return (
    <>
      {PricingContent.map((val, i) => (
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-dealy={val.delayAnimation}
          key={i}
        >
          <div className={`pr-table-wrapper md-mb-40 ${val.activeClass}`}>
            <img
              src={`images/icon/${val.icon}.svg`}
              alt="icon"
              className="icon"
            />
            <div className="pack-name">{val.packName}</div>
            <ul className="pr-feature">
              {val.features.map((list, i) => (
                <li key={i}>{list}</li>
              ))}
            </ul>

            <div className="price">
              Rp. {val.price}
              <span>/tahun</span>
            </div>
            <div className="trial-text">{val.trialText}</div>
            <a href="#" className="trial-button">
              Sign up
            </a>
          </div>
          {/* /.pr-table-wrapper */}
        </div>
      ))}
    </>
  );
};

export default PricingSeven;
